module.exports = __webpack_public_path__ + "img/matt-icons_dialog-question.9e95c756.svg";